module.exports = __webpack_public_path__ + "static/media/Group 3976.9bbe09e4.svg";